const formikMapper = {
  nameSpanish: 'name[0].text',
  nameEnglish: 'name[1].text'
};

export { formikMapper };
